import { render, staticRenderFns } from "./title.vue?vue&type=template&id=819b684c&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=819b684c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819b684c",
  null
  
)

export default component.exports